import { createFileRoute } from '@tanstack/react-router';
import { JourneysPeopleHandoff } from '@/pages/workspaces/people/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/profiles` URL — the canonical segment for accounts on
 * the taxonomy rename (the Ember router flag-swaps `people`/`profiles`). Flag
 * off it renders the embedded Ember host; flag on it forwards to the migrated
 * URL, same as the `/journeys/people` twin.
 */
function JourneysProfilesIndexRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysPeopleHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/profiles/')({
  component: JourneysProfilesIndexRoute,
});
